import { lazy } from 'react';

import type { RoutesConfig, WrapRoutes } from '@virtuslab/nfs-shared/src/services/routes';

import { AbsencesRoutes } from '../../../config/paths';

const AbsencesPage = lazy(async () => import('.'));

const config: RoutesConfig<WrapRoutes<typeof AbsencesRoutes>> = {
  paths: {
    [AbsencesRoutes.ABSENCES_FOR_DATE]: {
      render: AbsencesPage,
    },
    [AbsencesRoutes.ABSENCES]: {
      render: AbsencesPage,
    },
  },
};

export default config;
